// PublicRoute.js
import { Navigate, useLocation } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userRole = userData?.data?.user_role;
  const searchRedirectTarget = (() => {
    try {
      const params = new URLSearchParams(location.search || "");
      return decodeURIComponent(params.get("redirect") || "");
    } catch {
      return "";
    }
  })();
  const hashRedirectTarget = (() => {
    const hash = String(location?.hash || "").trim();
    if (!hash.startsWith("#/")) return "";
    const target = hash.slice(1);
    return target.startsWith("/login") ? "" : target;
  })();

  if (isAuthenticated) {
    return (
      <Navigate
        to={
          userRole === "student"
            ? (searchRedirectTarget || hashRedirectTarget || "/studenthomepage")
            : "/teacherhomepage"
        }
        replace
      />
    );
  }

  return children;
};

export default PublicRoute;
